<div class="content-card filters">
  <div class="top">
    <div class="top__left">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button mat-icon-button (click)="previousYear()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <span class="date-label" (click)="picker.open()">
            {{ currentDate | date : 'yyyy' }}
          </span>
          <button mat-icon-button (click)="nextYear()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
          <div class="datepicker">
            <input matInput [matDatepicker]="picker" readonly />
            <mat-datepicker #picker startView="multi-year" (yearSelected)="onDateChange($event, picker)"></mat-datepicker>
          </div>
          <button mat-icon-button (click)="picker.open()">
            <mat-icon>event</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="top__right">
      <div class="filter-button-container">
        <button (click)="resetFilters()" class="top__button top__button-clear">
          <mat-icon>close</mat-icon>
          {{ 'Reset' | translate }}
        </button>
        <button
          (click)="toggleFiltersPanel()"
          class="top__button top__button-filter"
          [matBadge]="filters.length"
          matBadgeSize="small"
          [matBadgeHidden]="!filters.length"
          >
          <mat-icon>filter_alt</mat-icon>
          {{ 'Filter' | translate }}
        </button>
      </div>
    </div>
  </div>
  @if (areFiltersExpanded) {
    <app-list-filter></app-list-filter>
  }
</div>
<div class="content-card table-container">
  <div class="table-wrapper custom-table">
    <mat-table #table matSort matSortActive="employer" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource.absences$ | async">
      <ng-container matColumnDef="workerFullName" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
          {{ 'WorkerFullName' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.LastName + ' ' + element.FirstName" [matTooltipPosition]="'above'"
          ><a [routerLink]="['/profile', element.WorkerId, 'absences']">{{ element.LastName }} {{ element.FirstName }}</a></mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="company">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'Company' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.Company" [matTooltipPosition]="'above'">{{ element.Company }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="employer">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'Employer' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.Employer" [matTooltipPosition]="'above'">{{ element.Employer }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="employerObject">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'EmployerObject' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.EmployerObject" [matTooltipPosition]="'above'">{{
            element.EmployerObject
          }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="employmentDateFrom">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'EmploymentDateFrom' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.EmploymentDateFrom | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="employmentDateTo">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'EmploymentDateTo' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.EmploymentDateTo | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        @for (month of romanMonths; track month) {
          <ng-container [matColumnDef]="month">
            <mat-header-cell *matHeaderCellDef class="hidden-sort">
              {{ month }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element[month] }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>
        }
        <ng-container matColumnDef="absenceSum" stickyEnd>
          <mat-header-cell *matHeaderCellDef class="hidden-sort">
            {{ 'AbsenceTabs.Absences.AbsenceSum' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.AbsenceSum" [matTooltipPosition]="'above'">{{ element.AbsenceSum }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="100%">{{ 'NoRecords' | translate }}</td>
        </tr>
      </mat-table>
    </div>
  </div>
  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>